import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {ReportIndexPresenter} from './ReportIndexPresenter';
import {Link} from 'react-router-dom';
import {Feedback} from '../../Components/Feedback';
import {Loader} from '../../Components/Utils/Loader';
import {ErrorPlaceholder} from '../../Components/Utils/ErrorPlaceholder';
import {NetworkRequestStatusView} from '../../Components/Utils/NetworkRequestStatusView';
import {ReportCard} from './Components/ReportCard';
import {CreateReport} from './Components/CreateReport';
import {FeatureFlags} from '../../../FeatureFlags';
import {AdvancedAdvert} from '../../Components/AdvancedAdvert';
import {format} from 'date-fns';

interface OwnProps {}

const ReportIndexComponent: FunctionComponent<OwnProps & PresenterProps<ReportIndexPresenter>> = observer(
    ({presenter}) => {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 d-flex flex-row justify-content-start">
                                <Link to="/workouts" className="btn btn-back-arrow">
                                    <i className="bi bi-arrow-left"></i>
                                </Link>
                                <h1>Your reports</h1>
                            </div>
                        </div>
                        {!FeatureFlags.reports && FeatureFlags.isAdvancedSubscriptionsEnabled && (
                            <AdvancedAdvert compact className="mb-3" />
                        )}
                        {FeatureFlags.reports && (
                            <div className="row">
                                <div className="col-12 col-md-9">
                                    <NetworkRequestStatusView
                                        result={presenter.reports}
                                        loader={() => <Loader className="mt-5" />}
                                        error={() => <ErrorPlaceholder large className="mt-5" />}
                                        component={(reports) => {
                                            return (
                                                <>
                                                    {reports.length === 0 && (
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <span className="workoutlist__empty">
                                                                            <span className="workoutlist__empty_image" />
                                                                            <span className="workoutlist__empty_text">
                                                                                <p>No reports found</p>
                                                                                <small>
                                                                                    Start by creating reports and adding
                                                                                    workouts to them.
                                                                                </small>
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="row">
                                                        {reports.slice(0, 3).map((report) => (
                                                            <div key={report.id} className="col-12 col-md-6">
                                                                <ReportCard className="mb-3" report={report} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {reports.length > 3 && (
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="card">
                                                                    <div className="workoutlist">
                                                                        <table className="table workoutlist__table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="workoutlist__table_cell">
                                                                                        Name
                                                                                    </th>
                                                                                    <th className="workoutlist__table_cell">
                                                                                        Description
                                                                                    </th>
                                                                                    <th className="workoutlist__table_cell">
                                                                                        Last snippet
                                                                                    </th>
                                                                                    <th className="workoutlist__table_cell">
                                                                                        Type
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {reports.slice(3).map((report) => (
                                                                                    <tr key={report.id}>
                                                                                        <td className="workoutlist__table_cell">
                                                                                            <Link
                                                                                                to={
                                                                                                    '/reports/' +
                                                                                                    report.id
                                                                                                }
                                                                                            >
                                                                                                {report.name}
                                                                                            </Link>
                                                                                        </td>
                                                                                        <td className="workoutlist__table_cell">
                                                                                            {report.description.length >
                                                                                            25
                                                                                                ? report.description.slice(
                                                                                                      0,
                                                                                                      25,
                                                                                                  ) + '...'
                                                                                                : report.description}
                                                                                        </td>
                                                                                        <td className="workoutlist__table_cell">
                                                                                            {report.latestSnippetAt ===
                                                                                            null
                                                                                                ? 'Empty report'
                                                                                                : format(
                                                                                                      report.latestSnippetAt,
                                                                                                      'dd-MM-yyyy',
                                                                                                  )}
                                                                                        </td>
                                                                                        <td className="workoutlist__table_cell">
                                                                                            {report.type === null
                                                                                                ? 'Unknown type'
                                                                                                : report.type}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-md-3">
                                    <CreateReport className="mb-3" />
                                    <Feedback />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    },
);

export const ReportsIndex = withPresenter<ReportIndexPresenter, OwnProps>(
    (props, component) => new ReportIndexPresenter(component.network.report),
    ReportIndexComponent,
);
